import { Theme } from '@mui/material';
import { styled } from '@mui/system';
import BoxMui from '@mui/material/Box';
import Button from '@mui/material/Button';

type ParamsStyle = {
    theme?: Theme;
    typeproduct: string;
    isOne: string;
}

export const Section = styled('section')(
    ({ theme }) => `
    
        padding: 0 0 2.18rem;

        nav {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: start;
            margin-bottom: 1.9rem;

            height: 2.5rem;

            h6 {
                padding-top: 4px;
            }

            h5 {
                font-size: 1.125rem;
                padding-left: .75rem; 
            }

            svg {
                position: absolute;
                height: 40px;
                width: auto;
            }
        }

        strong {
            color: ${theme.palette.secondary.main};
        }

        @media(min-width: ${theme.breakpoints.values.md}px) {
            padding: 1.35rem 0 1.35rem calc((100% - 62rem) / 2);

            nav {
                h5 {
                    font-size: 1.56rem;
                    padding: 4px 0 0 2.5rem; 
                }

                svg {
                    position: absolute;
                    height: 50px;
                    width: auto;
                }
            }
        }
`);

export const Box = styled(BoxMui)(
    ({ theme }) => `
        position: relative;
        display: flex;
        align-items: start;
        justify-content: start;
`);

export const ContainerIcon = styled(BoxMui)(
    ({ theme, typeproduct, isOne }: ParamsStyle) => `
        width: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        ${typeproduct === 'activeContainer' ? `
            height: 262px;
            padding: 60px 130px 50px 20px;
        `: `
            height: ${isOne === 'active' ? '239px' : '207px'};
            padding: 14px 130px 50px 20px;
        `}

        svg {
            width: 100%;
            height: 100%;
            
            max-width: 100%;
            max-height: 100%;
        }
`);

export const Template = styled('div')(
    ({ theme }) => `
        display: none;

        @media(min-width: ${theme.breakpoints.values.md}px) {
            display: block;

            nav {
                margin-bottom: 1.82rem;
            }
    
            ul {
                gap: .4rem;
                display: flex;
                flex-direction: column;
    
                li {
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    height: 1.25rem;
                    text-align: start;
                }
            }
        }
`);

export const SliderCards = styled('ul')(
    ({ theme }) => `
        width: 100%;

        .container-recommended {
            position: relative;
        }

        .scroll-container {
            width: 100%;
            gap: 1.18rem;
            cursor: grab;
            display: flex;
            overflow: auto;
            padding: .4rem 2rem 0 .4rem;
        }
        
        @media(min-width: ${theme.breakpoints.values.md}px) {
            .scroll-container {
                gap: 1rem;
                padding: .4rem 45rem 0 .4rem;
            }

            ::-webkit-scrollbar {
                width: 0px;
            }
        }
`);

export const ContentButton = styled('ul')(
    ({ theme }) => `
        width: 100%;
        bottom: 0px;
        position: absolute;
        padding: .75rem .75rem 9px;
        border-radius: 0px 0px 5px 5px;
        background-color: ${theme.palette.secondary.main};
        
        @media(min-width: ${theme.breakpoints.values.md}px) {

        }
`);

export const BoxButton = styled(BoxMui)(
    ({ theme }) => `
        display: flex;
        padding-top: .4rem;
        justify-content: space-between;

        @media(min-width: ${theme.breakpoints.values.md}px) {

        }
`);

export const ButtonCustom = styled(Button)(
    ({ theme }) => `
        margin: auto;
        display: none;
        height: 2rem;
        min-width: 2rem;
        padding: 4px 0px 0 0px;
        border-radius: 100%;
        background-color: #17A7E0;
        position: absolute;
        z-index: 1;
        top: 48px;
        bottom: 0;

        &:hover {
            background-color: #17A7E0;
            opacity: .9;
        }

        @media(min-width: ${theme.breakpoints.values.md}px) {
            display: block;
        }
`);